export const replaceTemplateWithFieldValue = (linkTargetTemplate = "") => ({ value }) => linkTargetTemplate.replace("{field_value}", String(value));
